import React, {
	useCallback,
	useEffect,
	useMemo,
	useRef,
	useState,
} from 'react';

function UseMemoTwo() {
	const [count, setCount] = useState(0);

	const expensiveCalculation = () => {
		return Math.random() * 1000;
	};

	const handleMultiply = useCallback(() => {
		setCount((curr) => curr * 124);
	}, [count]);

	// const renderValue = useMemo(() => expensiveCalculation(), [count]);

	return (
		<div>
			Count: {count}
			<button onClick={() => setCount(count + 1)}>Multiply!</button>
			<Multiplier handleClick={handleMultiply} />
		</div>
	);
}

const Multiplier = (handleClick: any) => {
	console.log('redner mulitple');
	return <div></div>;
};

export default UseMemoTwo;
